import React from 'react';
import { Box, Typography } from '@mui/material';
import TableWrapperBase from '../shared/table';
import { ItemCustomerUsageProps } from './item-customer-usage';
import { dataTypes } from '../shared/table-helpers';
import { printRoundedNumber } from '../../shared/utils';
import { sortTypes } from '../shared/sorting';
const TableWrapper = TableWrapperBase as any;

interface ItemCustomerUsageBreakdownProps {
  breakdownData: ItemCustomerUsageProps[];
  customerName: string;
}

export default function ItemCustomerUsageBreakdown({
  breakdownData,
  customerName,
}: ItemCustomerUsageBreakdownProps) {
  const columns = [
    {
      id: 'orderNo',
      label: 'Order No',
      dataType: dataTypes.salesOrderNumber,
    },
    {
      id: 'lastShipDate',
      label: 'Last Ship Date',
      dataType: dataTypes.date,
      isSortable: true,
    },
    {
      id: 'shipLocationName',
      label: 'SF',
      dataType: dataTypes.string,
    },
    {
      id: 'shsfLegacyLocationId',
      label: 'SHSF',
      dataType: dataTypes.string,
    },
    {
      id: 'qtyShipped',
      label: 'Qty Shipped',
      dataType: dataTypes.quantity,
      isSortable: true,
    },
  ];

  const totalQtyShipped = breakdownData.reduce(
    (sum, row) => sum + (row.qtyShipped || 0),
    0
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant='h6'>
        Usage Breakdown for <b>{customerName}</b> for item{' '}
        <b>{breakdownData[0]?.itemID}</b>
      </Typography>
      <TableWrapper
        showSearch
        transformRows
        columns={columns}
        rows={breakdownData}
        orderBy={'lastShipDate'}
        orderDirection={sortTypes.desc}
        style={{ width: '100%' }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Typography>
          {`Total Quantity Shipped: ${printRoundedNumber(totalQtyShipped, 0)}`}
        </Typography>
      </Box>
    </Box>
  );
}
